import type * as api from '@gitbook/api-client';
import { Inline } from '@gitbook/slate';

import { INLINE_BUTTON, type InlineButtonData } from '../types';

/**
 * Create a TeX math line
 */
export function createInlineButton(input: {
    ref: api.ContentRef;
    label?: string;
    kind?: InlineButtonData['kind'];
    icon?: string;
}) {
    const { ref, label = 'New button', kind = 'primary', icon } = input;

    return Inline.create({
        type: INLINE_BUTTON,
        isVoid: true,
        data: {
            ref,
            label,
            kind,
            ...(icon ? { icon } : {}),
        },
    });
}
